import axios from 'axios'
import { useStore } from '@/store'
import { ResponseCode } from './response'

// The legacy form interceptor drops null/empty values. This JSON API must preserve
// knowledgeBaseId=null (unbind) and workflowVersion='' (disabled configuration).
async function request(siteId, method, suffix = '', data, params) {
  const response = await axios.request({
    baseURL: process.env.VUE_APP_BASE_API,
    url: `/site/${siteId}/ai-config${suffix}`,
    method,
    data,
    params,
    timeout: 15000,
    headers: {
      Authorization: `Bearer ${useStore().state.user.token}`,
      'Content-Type': 'application/json',
    },
  })
  const body = response.data
  if (body.code !== ResponseCode.SUCCESS) {
    const error = new Error(body.message || 'AI configuration request failed')
    error.code = body.code
    throw error
  }
  return body.data
}

export const getAiSiteConfig = siteId => request(siteId, 'GET')
export const saveAiSiteConfig = (siteId, data) => request(siteId, 'PUT', '', data)
export const getAiSiteAudit = (siteId, beforeId) => request(siteId, 'GET', '/audit', undefined,
  beforeId == null ? undefined : { beforeId })

export const getAiReception = siteId => request(siteId, 'GET', '/reception')
export const saveAiReception = (siteId, data) => request(siteId, 'PUT', '/reception', data)
